import { render } from "./Product.vue?vue&type=template&id=38c28984&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=38c28984&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c28984"],['__file',"resources/js/modules/labelinsight-products/components/Product.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38c28984"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38c28984', __exports__)) {
    api.reload('38c28984', __exports__)
  }
  
  module.hot.accept("./Product.vue?vue&type=template&id=38c28984&scoped=true", () => {
    api.rerender('38c28984', render)
  })

}


export default __exports__